import useSWR from 'swr'

import {
  AnalyticsApiPath,
  GetAbResultsResponse,
  GetAbResultsVars,
  GetAlgorithmPerformanceResponse,
  GetAlgorithmPerformanceVars,
  GetOverviewResponse,
  GetOverviewVars,
  GetRecommendationPerformanceResponse,
  GetRecommendationPerformanceVars,
  GetServiceSummaryResponse,
  GetServiceSummaryVars,
  GetAlertsResponse,
  GetAlertsVars
} from '@/common/api/params/analytics'

export const useAnalyticsOverviewGetApi = (vars: GetOverviewVars = {}) => {
  return useSWR<GetOverviewResponse, Response, [string, GetOverviewVars]>([
    AnalyticsApiPath.GET_OVERVIEW,
    vars
  ])
}

export const useAnalyticsAbResultsGetApi = (vars: GetAbResultsVars = {}) => {
  return useSWR<GetAbResultsResponse, Response, [string, GetAbResultsVars]>([
    AnalyticsApiPath.GET_AB_RESULTS,
    vars
  ])
}

export const useAnalyticsAlgorithmPerformanceGetApi = (vars: GetAlgorithmPerformanceVars = {}) => {
  return useSWR<GetAlgorithmPerformanceResponse, Response, [string, GetAlgorithmPerformanceVars]>([
    AnalyticsApiPath.GET_ALGORITHM_PERFORMANCE,
    vars
  ])
}

export const useAnalyticsRecommendationPerformanceGetApi = (
  vars: GetRecommendationPerformanceVars
) => {
  return useSWR<
    GetRecommendationPerformanceResponse,
    Response,
    [string, GetRecommendationPerformanceVars]
  >([AnalyticsApiPath.GET_RECOMMENDATION_PERFORMANCE, vars])
}

export const useAnalyticsServiceSummaryGetApi = (vars: GetServiceSummaryVars = {}) => {
  return useSWR<GetServiceSummaryResponse, Response, [string, GetServiceSummaryVars]>([
    AnalyticsApiPath.GET_SERVICE_SUMMARY,
    vars
  ])
}

export const useAnalyticsAlertsGetApi = (vars: GetAlertsVars = {}) => {
  return useSWR<GetAlertsResponse, Response, [string, GetAlertsVars]>([
    AnalyticsApiPath.GET_ALERTS,
    vars
  ])
}
